// extracted by mini-css-extract-plugin
module.exports =  {"select":"AvRryjn_bySmeHrzVl_D","secondaryNav":"_y9Wm1NfFG0ycRqoiprB"};